import { render, staticRenderFns } from "./soil.vue?vue&type=template&id=3d1c88c2&scoped=true&"
import script from "./soil.vue?vue&type=script&lang=js&"
export * from "./soil.vue?vue&type=script&lang=js&"
import style0 from "./soil.vue?vue&type=style&index=0&id=3d1c88c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c88c2",
  null
  
)

export default component.exports